import { render } from "./BulkActionsClearList.vue?vue&type=template&id=7d90139d"
import script from "./BulkActionsClearList.vue?vue&type=script&lang=js"
export * from "./BulkActionsClearList.vue?vue&type=script&lang=js"

import exportComponent from "/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__